import React from "react";

import { css } from "@emotion/react";

import { HeaderSpacer } from "../../_layout-helpers/spacers";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { ContentContainer } from "../../../components/_shared-components/arrangement/Container";
import { HeaderComponent } from "../../../components/HeaderComponent/HeaderComponent";
import { FooterComponent } from "../../../components/FooterComponent/FooterComponent";
import { UITabs } from "../../../components/StoriesOverviewComponent/ui-tabs/UITabs";
import { VideoStoriesOverviewComponents } from "../../../components/StoriesOverviewComponent/Videos/VideoStoriesOverviewComponents";
import { useLocation } from "react-router";
import { PageMetadataComponent } from "../../../components/PageMetadataComponent/PageMetadataComponent";
import { ExtractSwarovskiPageData } from "@swo/storefront";
import { VideoStoriesOverviewPageData } from "@swo/storefront";
import { useStore } from "../../../store/hooks/use-store";
import { T } from "../../../components/T";

export const VideoStoriesOverviewPageLayout: React.FC<
  ExtractSwarovskiPageData<VideoStoriesOverviewPageData>
> = props => {
  const location = useLocation();
  const { locationOrigin } = useStore().state;

  const tabElements = [
    { label: <T>{props.data.storiesLabel}</T>, link: props.data.storiesOverviewLink, isActive: false },
    { label: <T>{props.data.videosLabel}</T>, link: location.pathname, isActive: true },
  ];

  return (
    <React.Fragment>
      <PageMetadataComponent
        {...props.data.metadata}
        locationOrigin={locationOrigin}
        canonicalPath={props.page.path}
        languageIsoCode={props.locale.language.isoCode}
      />
      <HeaderComponent header={props.data.header} version={"normal"} />
      <HeaderSpacer />

      <ContentContainer>
        <UITabs elements={tabElements} />
        <Spacer size={"md"} />
        <VideoStoriesOverviewComponents
          mainTeaser={props.data.mainVideoTeaser}
          videoStoryElements={props.data.teasers.map(t => ({
            ...t,
            tags: t.tags.map(t => ({ ...t, expandedLink: { pathname: "#", search: undefined } })),
          }))}
        />
      </ContentContainer>

      <Spacer size={"lg"} />
      <FooterComponent {...props.data.footer} />
    </React.Fragment>
  );
};
